import React from 'react';
import AgreementDialog from './AgreementDialog';
import {useSelector} from 'react-redux';
import {selectConductAgreement} from '../../selectors/eula.selectors';
import {Eula} from '../../reducers/eula.reducer';
import {RootState} from '../..';

interface Props {
    open: boolean;
    onClose: (event?) => void;
}

const ConductDialog: React.FunctionComponent<Props> = props => {
    const agreement = useSelector<RootState, Eula>(selectConductAgreement);
    return <AgreementDialog eula={agreement} {...props} />;
};

export default React.memo(ConductDialog);
